module.exports = __webpack_public_path__ + "img/dylan-1.c74bc761.jpg";